export default {
  title_one: 'Actualizando estadísticas de entrega de «{{title}}»',
  title_other: 'Actualizando estadísticas de entrega de {{count}} campañas',
  subtitle_pending:
    'Apple y Google confirman la recepción en aprox. {{minutes}}m {{seconds}}s (alrededor de las {{time}}). Las estadísticas se actualizarán automáticamente.',
  subtitle_ready: 'Los registros ya deberían estar. Actualiza la página para ver los últimos datos de entrega.',
};
